import "../styles/HomeNew.css";

export default function Contact() {
  return (
    <div className="pg">

      {/* ── HERO ── */}
      <section className="hero" style={{ minHeight: "40svh" }}>
        <div className="hero__glow hero__glow--1" />
        <div className="hero__glow hero__glow--2" />
        <div className="hero__glow hero__glow--3" />
        <div className="hero__inner" style={{ gridTemplateColumns: "1fr" }}>
          <div className="hero__text">
            <p className="hero__kicker">For A Better Tomorrow</p>
            <h1 className="hero__h1">
              Contact <span className="hero__accent">Us</span>
            </h1>
            <p className="hero__sub">
              Don't hesitate to ask us something. We're here to help and we'd love
              to hear from you — whether you're curious about our programs, want to
              volunteer, or are ready to submit a grant.
            </p>
            <div className="hero__ctas">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSdXwatTsVLGTCRWtrErwZUnND1_r4ioQgPH1_6EtzO-EW1RrA/viewform"
                target="_blank"
                rel="noopener noreferrer"
                className="cta cta--solid"
              >
                Share Your Story
              </a>
              <a href="/grant" className="cta cta--ghost">Submit a Grant ↗</a>
            </div>
          </div>
        </div>
      </section>

      {/* ── CONTACT CARDS ── */}
      <section className="events" style={{ maxWidth: "860px", marginInline: "auto" }}>
        <div className="sec-hd">
          <span className="sec-eye">Get in Touch</span>
          <h2 className="sec-h2">Reach Out</h2>
          <p className="sec-sub">Available from 9 AM to 5 PM.</p>
        </div>

        <div className="events__grid">

          {/* Phone */}
          {
            <div className="ecard card--purple" style={{ cursor: "default" }}>
              <div className="ecard__icon">📞</div>
              <div className="ecard__img" style={{
                display: "flex", alignItems: "center", justifyContent: "center",
                background: "var(--pu-100)", fontSize: "3.5rem",
              }}>
                📱
              </div>
              <span className="ecard__label">Phone</span>
              <h3 className="ecard__name">Call Us</h3>
              <p className="ecard__desc">Reach us by phone during regular business hours.</p>
              <a href="tel:3098385254" className="ecard__arrow" style={{ color: "var(--pu-500)" }}>
                309-838-5254 →
              </a>
            </div>
          }

          {/* Email */}
          <div className="ecard card--pink" style={{ cursor: "default" }}>
            <div className="ecard__icon">✉️</div>
            <div className="ecard__img" style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "var(--pk-100)", fontSize: "3.5rem",
            }}>
              📧
            </div>
            <span className="ecard__label">Email</span>
            <h3 className="ecard__name">Email Us</h3>
            <p className="ecard__desc">Send us a message and we'll get back to you.</p>
            <a href="mailto:contactus@forbettertomorrow.org" className="ecard__arrow" style={{ color: "var(--pk-500)" }}>
              contactus@forbettertomorrow.org →
            </a>
          </div>

          {/* Grant */}
          <div className="ecard card--green" style={{ cursor: "default" }}>
            <div className="ecard__icon">📋</div>
            <div className="ecard__img" style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              background: "var(--gn-100)", fontSize: "3.5rem",
            }}>
              📝
            </div>
            <span className="ecard__label">Grants</span>
            <h3 className="ecard__name">Submit a Grant</h3>
            <p className="ecard__desc">Interested in partnering with FBT? Submit your grant request.</p>
            <a href="/grant" className="ecard__arrow" style={{ color: "var(--gn-500)" }}>
              Apply now →
            </a>
          </div>

        </div>
      </section>

      {/* ── MAP & ADDRESS ── */}
      <section className="local" style={{ maxWidth: "860px", marginInline: "auto" }}>
        <div className="lcard lcard--open" style={{ padding: "2rem", gap: "1.25rem" }}>
          <div style={{ display: "flex", alignItems: "center", gap: ".75rem" }}>
            <span style={{ fontSize: "1.4rem" }}>📍</span>
            <div>
              <h3 style={{ fontFamily: "var(--ff-head)", fontSize: "1.1rem", fontWeight: 800, color: "var(--ink)" }}>
                Our Location
              </h3>
              <p style={{ fontSize: ".85rem", color: "var(--muted)", marginTop: ".2rem" }}>
                808 S. Eldorado Road, Suite 1 · Bloomington, IL 61704
              </p>
            </div>
          </div>
          <div style={{
            borderRadius: "12px",
            overflow: "hidden",
            border: "1.5px solid var(--pu-200)",
            aspectRatio: "16/6",
          }}>
            <iframe
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyD09zQ9PNDNNy9TadMuzRV_UsPUoWKntt8&q=808+S+Eldorado+Road+Suite+1+Bloomington+IL+61704+United+States"
              width="100%"
              height="100%"
              style={{ border: 0, display: "block" }}
              allowFullScreen
              loading="lazy"
              title="FBT Location"
            />
          </div>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSdXwatTsVLGTCRWtrErwZUnND1_r4ioQgPH1_6EtzO-EW1RrA/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="lcard__toggle"
            style={{ alignSelf: "flex-start" }}
          >
            Share your story →
          </a>
        </div>
      </section>

    </div>
  );
}